import { fetchApi } from "containers/helpers";

export const getIssues = (path) => fetchApi(path)